module.exports = __webpack_public_path__ + "static/img/task-empty.cc2a957e.png";